import { CurrentUserRoleType } from '~/graphqls/types'

export type UserRoleType = {
  /** 是否是ai创作者 */
  artist?: boolean | null
  /** 是否是普通创作者 */
  aiArtist?: boolean | null
}
/** 获取用户当前角色 */
export const getCurrentUserRole = (userRoleInfo?: UserRoleType | null) => {
  const isCreator = userRoleInfo?.artist
  const isAiCreator = userRoleInfo?.aiArtist
  let userRole
  if (isAiCreator && isCreator) {
    // 双身份
    userRole = CurrentUserRoleType.ARTIST_AND_AIARTIST
  } else if (isAiCreator) {
    // 单ai创作者
    userRole = CurrentUserRoleType.AI_ARTIST
  } else if (isCreator) {
    // 单普通创作者
    userRole = CurrentUserRoleType.ARTIST
  } else {
    // 普通用户
    userRole = CurrentUserRoleType.ORDINARY
  }
  return userRole
}
